import { z } from "zod";

export const projectSchema = z.object({
	id: z.string().optional().nullable(),
	name: z.string().min(1, "Project name is required"),
	description: z.string().optional().nullable(),
	client_id: z.string().optional().nullable(),
	client: z
		.object({
			id: z.string(),
			name: z.string(),
			company: z.string().nullable(),
			email: z.string().nullable(),
		})
		.optional()
		.nullable(),
	date_start: z.string().optional().nullable(),
	status: z.enum(["active", "inactive", "completed"]),
	category: z.enum(["one-time", "recurring", "recurring-one-time"]).default("one-time"),
	contact_person: z.string().optional().nullable(),
	contact_number: z.string().optional().nullable(),
	noa_date: z.string().optional().nullable(),
	ntp_date: z.string().optional().nullable(),
	contract_date: z.string().optional().nullable(),
	purchase_order: z.string().optional().nullable(),
	notes: z.string().optional().nullable(),
	is_active: z.boolean().optional(),
	created_at: z.string().optional().nullable(),
	updated_at: z.string().optional().nullable(),
	deleted_at: z.string().optional().nullable(),
});

export type Project = z.infer<typeof projectSchema>;

export const createProjectSchema = projectSchema.omit({
	id: true,
	is_active: true,
	created_at: true,
	updated_at: true,
	deleted_at: true,
});

export type CreateProjectData = z.infer<typeof createProjectSchema>;

export const updateProjectSchema = createProjectSchema.partial().extend({
	id: z.string(),
});

export type UpdateProjectData = z.infer<typeof updateProjectSchema>;
